import { useState } from 'react';
import Slider from 'react-slick';
import styles from './ReviewCarousel.module.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface Review {
  id: number;
  author: string;
  text: string;
  rating: number;
}

const settings = {
  className: 'slider variable-width',
  arrows: false,
  focusOnSelect: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

function ReviewCarousel() {
  const [reviews] = useState<Review[]>([
    {
      id: 1,
      author: 'Maria Silva',
      text: `Excelente experiência! As oficinas são muito bem organizadas.
            Lorem ipsum dolor sit amet consectetur adipisicing elit.Voluptate repellat, soluta eius.
            `,
      rating: 5,
    },
    {
      id: 2,
      author: 'João Santos',
      text: 'O almanaque é incrível, meus filhos adoraram!',
      rating: 5,
    },
    {
      id: 3,
      author: 'Ana Oliveira',
      text: 'Ótimo conteúdo educativo e divertido.',
      rating: 4,
    },
  ]);

  return (
    <Slider {...settings} className={styles.carousel}>
      {reviews.map((review) => (
        <div key={review.id} className={styles.item}>
          <div className={styles.review}>
            <p className={styles.text}>{review.text}</p>
            <p className={styles.author}>- {review.author}</p>
            <div className={styles.rating}>
              {[...Array(review.rating)].map((_, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <span key={i} className={styles.star}>
                  ★
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
}

export default ReviewCarousel;
